<template>
  <div class="initscreen">
    <div class="initscreen-center">
      <div class="initscreen-spinner"></div>
      <div class="text-center">
        <div class="initscreen-phrases">
          <div class="initscreen-phrase">Loading</div>
        </div>
      </div>
    </div>
    <div class="initscreen-logo-wrapper">
      <a href="https://cleanscripts.com" title="Aplikacje dedykowane" class="initscreen-logo">
        <img src="../assets/image/cs_logo-w160_grey.png" alt="logo CleanScripts" />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "TheLoadScreen"
};
</script>